export default "__VITE_PUBLIC_ASSET__c8cdd13f__"